module.exports = __webpack_public_path__ + "img/RO.d8a79d9f.svg";